import { render, staticRenderFns } from "./merchandisesTotalPrice.vue?vue&type=template&id=6959b97a&scoped=true&"
import script from "./merchandisesTotalPrice.vue?vue&type=script&lang=js&"
export * from "./merchandisesTotalPrice.vue?vue&type=script&lang=js&"
import style0 from "./merchandisesTotalPrice.vue?vue&type=style&index=0&id=6959b97a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6959b97a",
  null
  
)

export default component.exports